/* src/app/calendar/pages/calendar-view/calendar-view.component.scss */
.calendarHeader {
  width: 100%;
  color: white;
  padding: 1rem;
  text-align: left;
  font-weight: bold;
}
/*# sourceMappingURL=calendar-view.component.css.map */
